import AccordionItem from 'components/shared/BaseAccordion/AccordionItem/AccordionItem';
import { getIdFromText } from 'utils/formatters';
import { ToggleClassNames, ToggleProps } from './types';
import { Colorways } from 'types/constants';

import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn } from '@/utils/styles';
import { StyleVariant } from './constants';

const Toggle = ({ sys, tabCopy, accordionItems, color, variant = StyleVariant.Default, classNames }: ToggleProps) => {
  const isDarkColorway = color === Colorways.Primary || color === Colorways.Secondary;

  const internalClassNames: ToggleClassNames = {
    wrapper: cn('panel mt-6 md:mt-14', classNames?.wrapper),
    accordion: {
      wrapper: cn(classNames?.accordion?.wrapper),
      details: cn(
        'open:mb-2 px-6 open:p-6 md:open:-mx-6 md:px-0 open:[&_td]:text-[unset]',
        {
          'md:px-6 py-6 open:rounded-[16px]': variant === StyleVariant.Secondary,
          'open:rounded-md': variant !== StyleVariant.Secondary,
          'open:light-green-colorway': variant !== StyleVariant.Secondary && !isDarkColorway,
          'open:dark-green-colorway': variant !== StyleVariant.Secondary && isDarkColorway,
        },
        classNames?.accordion?.details,
      ),
      summary: cn(classNames?.accordion?.summary),
      headline: cn(classNames?.accordion?.headline),
      copy: cn(classNames?.accordion?.copy),
    },
  };

  return (
    <div
      className={internalClassNames.wrapper}
      id={`panel-${getIdFromText(tabCopy)}`}
      {...liveUpdateAttrs(sys?.id, 'content')}>
      {accordionItems.items?.map((item, i) => (
        // We intentionally do not pass isFirstElement as a prop to AccordionItem because
        // we do not want the first item to be open by default for the Toggle component
        <AccordionItem
          sectionName={item.sectionName}
          sys={item.sys}
          accordionLabelRte={item.accordionLabelRte}
          accordionCopy={item.accordionCopy}
          key={`accordion-item-${i}`}
          classNames={internalClassNames.accordion}
          showSimpleListStyle
          variant={variant}
        />
      ))}
    </div>
  );
};

export default Toggle;
